import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const NAV_LINKS = [
  { to: "/",           label: "Home"          },
  { to: "/about",      label: "About"         },
  { to: "/services",   label: "Services"      },
  { to: "/gallery",    label: "Gallery"       },
  { to: "/compliance", label: "Compliance"    },
  { to: "/contact",    label: "Contact"       },
];

export const Navigation = () => {
  const [navCollapsed, setNavCollapsed] = useState(true);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  const closeNav = () => setNavCollapsed(true);
  const toggleNav = () => setNavCollapsed((v) => !v);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Close mobile menu on route change
  useEffect(() => { setNavCollapsed(true); }, [pathname]);

  return (
    <>
      {!navCollapsed && (
        <div
          className="navbar-backdrop"
          onClick={closeNav}
          style={{
            position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)", zIndex: 999,
          }}
        />
      )}
      <nav
        id="menu"
        className="navbar navbar-default navbar-fixed-top"
        style={{ top: scrolled ? "0px" : "49px", transition: "top 0.3s ease" }}
      >
        <div className="container">
          <div className="navbar-content-wrapper">
            <div className="navbar-header" style={{ display: navCollapsed ? "flex" : "none" }}>
              <Link className="navbar-brand" to="/" onClick={closeNav}>
                <img src="/img/logo/logo.png" alt="Transwave Shipping Logo" className="navbar-logo" />
              </Link>
              <button
                type="button"
                className={navCollapsed ? "navbar-toggle collapsed" : "navbar-toggle"}
                onClick={toggleNav}
                aria-expanded={!navCollapsed}
                aria-label="Toggle navigation"
              >
                <span className="sr-only">Toggle navigation</span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
              </button>
            </div>

            <div
              className={navCollapsed ? "collapse navbar-collapse" : "collapse navbar-collapse in"}
              id="bs-example-navbar-collapse-1"
              style={{ display: navCollapsed ? "none" : "flex" }}
            >
              <ul className="nav navbar-nav navbar-right">
                {NAV_LINKS.map(({ to, label, cta }) => (
                  <li key={label} className={[pathname === to && !cta ? "active" : "", cta ? "nav-cta-item" : ""].filter(Boolean).join(" ") || undefined}>
                    <Link to={to} onClick={closeNav}>{label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};
